import { cn } from '@/lib/utils';

interface AppLogoProps {
    containerClassNames?: string;
    imgClassNames?: string;
}

export default function AppLogo({ containerClassNames, imgClassNames }: AppLogoProps) {
    return (
        <>
            <div className={cn('', containerClassNames)}>
                <img
                    src="/cn-logo-wide.png"
                    alt="Compre Nautica Logo"
                    width={96}
                    height={60}
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    className={cn('h-[3.75rem] w-auto object-contain', imgClassNames)}
                />
            </div>
        </>
    );
}
